import React, {FC, memo} from "react";
import moment, {Moment} from "moment";
import classnames from "classnames";
// import { Form } from '@ant-design/compatible';
// import '@ant-design/compatible/assets/index.css';
import {Form} from "antd";
import {FormItemProps} from "antd/lib/form";
import css from "./CourseDateInput.less";
import {ISODateString} from "../../helpers/typeScriptHelpers";
import DateInput from "../DateInput/DateInput";

type CourseDateInputProps = Pick<FormItemProps, "validateStatus" | "help"> & {
    label: string;
    isGreyedOut?: boolean;
    onChange?: (newDate: Moment | null) => void;
    style?: React.CSSProperties;
    testId?: string;
    value?: ISODateString;
};

const CourseDateInput: FC<CourseDateInputProps> = ({
    label,
    testId,
    onChange = () => undefined,
    isGreyedOut,
    validateStatus,
    help,
    value,
    ...props
}) => {
    return (
        <div
            className={classnames(css.root, {[css.isGreyedOut]: isGreyedOut})}
            data-testid={testId}
            {...props}
        >
            <Form.Item
                label={label}
                validateStatus={validateStatus}
                help={help}
                required
            >
                <DateInput
                    allowClear={false}
                    style={{width: "100%"}}
                    onChange={onChange}
                    value={moment(value)}
                />
            </Form.Item>
        </div>
    );
};

export default memo(CourseDateInput);
